module.exports = __webpack_public_path__ + "mainassets/img/main2.187b880f.jpg";